import React from 'react';

import type { GridCellParams } from '@mui/x-data-grid-premium';
import type { GroupRow } from 'src/components/admin';
import { GroupLabelList } from 'src/workflow/labels';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(_theme => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
  },
}));

export function LabelsCell({ row }: GridCellParams<GroupRow, GroupRow['labels']>): JSX.Element {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <GroupLabelList
        group={row}
        popoverProps={{
          anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
          style: { transform: `translateY(4px)` },
          transformOrigin: { horizontal: 'left', vertical: 'top' },
        }}
      />
    </div>
  );
}
